import type { ReactNode } from 'react';
import type { Locale } from '../shared/types';
import { text } from './ui';
import './admin-navigation.css';

export const GENERAL_ADMIN_VIEWS = ['events', 'contacts', 'unsubscribed', 'logs'] as const;
export const EVENT_ADMIN_VIEWS = ['dashboard', 'invitees', 'email', 'event', 'sync'] as const;
export type AdminView = typeof GENERAL_ADMIN_VIEWS[number] | typeof EVENT_ADMIN_VIEWS[number];

export function AdminNavigation({ locale, view, items, eventPicker, icon, onNavigate }: {
  locale: Locale; view: AdminView; items: ReadonlyArray<readonly [AdminView, string]>; eventPicker: ReactNode;
  icon: (view: AdminView) => ReactNode; onNavigate: (view: AdminView) => void;
}) {
  const general = new Set<AdminView>(GENERAL_ADMIN_VIEWS);
  function links(global: boolean) {
    return items.filter(([id]) => general.has(id) === global).map(([id, label]) =>
      <button key={id} type="button" className={view === id ? 'active' : ''} aria-current={view === id ? 'page' : undefined} onClick={() => onNavigate(id)}>{icon(id)}{label}</button>);
  }
  return <div className="admin-navigation">
    <section className="admin-nav-group" aria-labelledby="general-nav-heading">
      <h2 id="general-nav-heading" className="admin-nav-heading">{text(locale, 'Genel', 'General')}</h2>
      <nav aria-label={text(locale, 'Genel sayfalar', 'General pages')}>{links(true)}</nav>
    </section>
    <section className="admin-nav-group admin-nav-group--event" aria-labelledby="event-nav-heading">
      <h2 id="event-nav-heading" className="admin-nav-heading">{text(locale, 'Seçili etkinlik', 'Selected event')}</h2>
      {eventPicker}
      <nav aria-label={text(locale, 'Seçili etkinlik sayfaları', 'Selected event pages')}>{links(false)}</nav>
    </section>
  </div>;
}
